/* React */
import React from "react";

/* React Spring */
import { useSpring, animated } from "@react-spring/web";

/* Simple Bar */
import SimpleBar from "simplebar-react";

/* Ionic */
import { IonGrid, IonRow } from "@ionic/react";

/* Stylesheet */
import styles from "./CustomCohortsWrapper.module.scss";

/* Interfaces */
interface CustomCohortsWrapperProps {
  showCohortList: boolean;
  children: React.ReactNode[];
}

const CustomCohortsWrapper: React.FC<
  CustomCohortsWrapperProps
> = ({ showCohortList, children }) => {
  const cohortBuilderAnimation = useSpring({
    width: showCohortList
      ? "calc(100% - 520px)"
      : "calc(100% - 72px)",
    config: { tension: 120, friction: 20 },
  });

  const cohortListAnimation = useSpring({
    width: showCohortList ? "520px" : "72px",
    config: { tension: 120, friction: 20 },
  });

  return (
    <IonGrid className={styles.custom_cohorts_wrapper}>
      <IonRow className={styles.row}>
        <animated.div
          style={cohortBuilderAnimation}
          className={`${styles.col} ${styles.cohort_builder_col}`}
        >
          <SimpleBar style={{ height: "100%" }}>
            <div className={styles.wrapper_container}>
              {children[0]}
            </div>
          </SimpleBar>
        </animated.div>
        <animated.div
          style={cohortListAnimation}
          className={`${styles.col} ${styles.cohort_list_col}`}
        >
          <div className={styles.wrapper_container}>
            <div className={styles.cohort_list_col}>
              {children[1]}
            </div>
          </div>
        </animated.div>
      </IonRow>
    </IonGrid>
  );
};

export default CustomCohortsWrapper;
